<template v-if="card">
  <div>
    <select-read-model-combobox
      v-if="card.cardType?.domainModelRole === DomainModelRole.READ_MODEL"
      :events="[event]"
      :cardIds="[card.id]"
      :style="{
        '--borderColor': card.isInContext ? cardTypeColor : '#868686',
        '--borderTopWidth': '1px'
      }"
      @selectedSchemaType="onSelectedSchemaType"
    />
    <text-editor
      v-if="card.cardType?.domainModelRole === DomainModelRole.COMMAND"
      class="pa-1"
      :id="card.id"
      :text="card.description"
      :disabled="store.state.isWorkflowDisabled"
      @text-update="(e) => updateDescription(e, card.id)"
      @text-delta="emit('text-delta')"
      @move-focus="moveFocus"
      @keydown.native.stop=""
      :borderColor="cardTypeColor"
    />
    <tag-input
      v-if="card.cardType?.domainModelRole === DomainModelRole?.TAG"
      class="pa-1"
      :cardId="card.id"
    />
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import TextEditor from '@/components/TextEditor'
import SelectReadModelCombobox from '@/components/SelectReadModelCombobox.vue'
import TagInput from '@/components/TagInput'
import workflowApi from '@/api/workflowApi'
import { DomainModelRole } from '@/constants/cardTypes'
import { SchemaType } from '@/constants/schema'
import { diagramHelpers } from '@/mixins/diagramHelpers'
import cardTypesApi from '@/api/cardTypesApi'

const { event, card } = defineProps({
  event: Object,
  card: Object
})
const emit = defineEmits(['text-delta', 'selectedSchemaType'])

const store = useStore()
const route = useRoute()
const cardTypes = computed(() => store.state.cardTypes.cardTypes)
const domainEventCardType = computed(() => diagramHelpers.methods.getDomainEventCardType(cardTypes.value))
const linkedSchemaType = ref(null)

const cardTypeColor = computed(() => {
  if (linkedSchemaType.value === SchemaType.DOMAIN_EVENT && domainEventCardType.value) {
    return cardTypesApi.getBackgroundColour(domainEventCardType.value)
  }
  const color = card?.cardType?.color
  return (color && `rgb(${color.red},${color.green},${color.blue})`) || 'transparent'
})

const onSelectedSchemaType = (type) => {
  linkedSchemaType.value = type
  emit('selectedSchemaType', type)
}

const moveFocus = (_, target) => {
  target.firstChild.blur()
}

const updateDescription = (html, itemId) => {
  workflowApi.updateCardsMutation(route.params.id, [{ cardId: itemId, description: html }])
}
</script>

<style scoped>
.card-item {
  min-width: 200px;
  max-width: 300px;
  margin: 0 auto;
  overflow: hidden;
  padding: 12px;
  border-radius: 8px;
  background: var(--light-1);
  border-width: 2px 1px 1px 1px;
  border-style: solid;
  border-color: var(--text-dark);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
}

.textEditor.ql-editor.ql-container {
  min-height: 31px;
}
</style>
